import type { ShopConfig } from '../store/auth'
import { useAuthStore } from '../store/auth'

/**
 * Last-resort currency when the session carries neither a shop nor a consumer currency (only
 * possible if the TradeInConfig fetch failed and ConsumerLogin returned no currency). Mirrors
 * `tradeinsearch2`'s own `TRADE_IN_SEARCH2_DEFAULT_CURRENCY`, so this degenerate case behaves as
 * before — the difference being that we now *say* it, rather than letting the endpoint decide.
 */
export const DEFAULT_SEARCH_CURRENCY = 'DKK'

/**
 * The currency catalogue searches are priced in. The shop's base currency leads: offers created
 * from a match are shown through `useMoneyFmt`, which converts shop→consumer, so results must
 * arrive on the shop basis or the figures would be converted twice.
 *
 * Always resolves to a real currency — `tradeinsearch2` has a default of its own, and relying on it
 * would leave the client unable to tell Core which currency a result was priced in when the match is
 * later added via `PotentialCreate`.
 */
export function resolveSearchCurrency(config: ShopConfig): string {
  return config.shopCurrency || config.currency || DEFAULT_SEARCH_CURRENCY
}

/** Hook form of {@link resolveSearchCurrency}, reading the currencies off the authenticated session. */
export function useSearchCurrency(): string {
  const shopCurrency = useAuthStore((s) => s.config.shopCurrency)
  const currency = useAuthStore((s) => s.config.currency)
  return resolveSearchCurrency({ shopCurrency, currency })
}
